import { createFileRoute } from '@tanstack/react-router';
import { InHouseReportLayoutRegistryPage } from './-components/InHouseReportLayoutRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/in-house-reports/')({
  component: InHouseReportLayoutRegistryPage
});